import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DataViewModule } from 'primeng/dataview';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { TextareaModule } from 'primeng/textarea';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';

@NgModule({
  imports: [
    AccordionModule,
    ButtonModule,
    CheckboxModule,
    CommonModule,
    DataViewModule,
    DatePickerModule,
    DialogModule,
    FormsModule,
    InputMaskModule,
    InputTextModule,
    MessageModule,
    MultiSelectModule,
    PanelModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    RadioButtonModule,
    ReactiveFormsModule,
    RouterModule,
    ScrollPanelModule,
    SelectModule,
    SelectButtonModule,
    TabsModule,
    TableModule,
    TextareaModule,
    TooltipModule,
    TreeModule
  ],
  declarations: [],
  exports: [
    AccordionModule,
    ButtonModule,
    CheckboxModule,
    CommonModule,
    DataViewModule,
    DatePickerModule,
    DialogModule,
    FormsModule,
    InputMaskModule,
    InputTextModule,
    MessageModule,
    MultiSelectModule,
    PanelModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    RadioButtonModule,
    ReactiveFormsModule,
    RouterModule,
    ScrollPanelModule,
    SelectModule,
    SelectButtonModule,
    TabsModule,
    TableModule,
    TextareaModule,
    TooltipModule,
    TreeModule
  ],
  providers: []
})
export class CommonSharedModule {}
